<mat-icon
  *ngIf="!active"
  class="__icon c-filter-icon-icon"
  [class.is-disabled]="disabled">
  filter_list
</mat-icon>

<mat-icon
  *ngIf="active"
  class="__icon __icon--cancel c-filter-icon-icon"
  [title]="titleText"
  [class.is-disabled]="disabled"
  (click)="resetTrigger.emit()">
  cancel
</mat-icon>
